// Subnav Link Types
export const LINK_TYPES = {
  LIVE_COVERAGE: 'LIVE COVERAGE',
  EXTERNAL_LINK: 'externalLink',
  ARTICLE: 'article',
};

// Package Headers
export const PKG_HEADERS = { GO_BIG: '2', STANDARD: '1', NONE: '0' };
